import React, { useState } from "react";
import { BsClipboard, BsPen, BsPlusCircle, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import CreateOrUpdateOnbaord from "../create-update-template/createOrUpdateOnboard";
import { APP_URL } from "constants/environment";
import { deleteOnboardTemplateAPI } from "Api/onBoardAPI";

const EditOrDeleteOnboard = ({ rowData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const { setMessageFormData, setFetchMessage, setIsOpenMessageEditForm } =
    useGlobalContext();

  const handleDeleteConfirm = async () => {
    if (!rowData?.id) return;
    const token = localStorage.getItem("jwtToken");
    const response = await deleteOnboardTemplateAPI(
      { id: rowData.id },
      () => {},
      token
    );
    if (response) {
      toast.success("Template deleted successfully");
      setFetchMessage(true);
    }
    setIsModalOpen(false);
  };

  const handleEdit = () => {
    const data = { ...rowData };

    data.templateType = data.templateType || data.type;

    if (data.templateType === "signUp") {
      data.booking = data.booking || data.signUp?.booking || "flight";
      data.title = data.title || data.signUp?.title || "";
      data.subTitle = data.subTitle || data.signUp?.subTitle || "";
      data.specs = data.specs || data.signUp?.specs || [];
      data.showLoginButton =
        data.showLoginButton ?? data.signUp?.showLoginButton ?? false;
      data.showDownArrow =
        data.showDownArrow ?? data.signUp?.showDownArrow ?? false;
      data.paramValue = data.paramValue || data.signUp?.paramValue || "";
    } else if (data.templateType === "welcome") {
      data.welcome = data.welcome || {
        title: data.welcome?.title || "",
        subTitle: data.welcome?.subTitle || "",
        buttonName: data.welcome?.buttonName || "",
        loginLink: data.welcome?.loginLink || "",
      };
    }

    setMessageFormData(data);
    setIsOpenMessageEditForm(true);
  };

  const handleAdd = () => {
    const newData = { ...rowData };
    delete newData.id;

    newData.templateType = newData.templateType || newData.type;

    if (newData.templateType === "signUp") {
      newData.booking = newData.booking || newData.signUp?.booking || "flight";
      newData.title = newData.title || newData.signUp?.title || "";
      newData.subTitle = newData.subTitle || newData.signUp?.subTitle || "";
      newData.specs = newData.specs ||
        newData.signUp?.specs || [{ icon: "check_small", label: "Spec" }];
      newData.showLoginButton =
        newData.showLoginButton ?? newData.signUp?.showLoginButton ?? false;
      newData.showDownArrow =
        newData.showDownArrow ?? newData.signUp?.showDownArrow ?? false;
      newData.paramValue = `${
        newData.paramValue || newData.signUp?.paramValue || "param"
      }_copy`;
    }

    if (newData.templateType === "welcome") {
      newData.welcome = newData.welcome || {
        title: "",
        subTitle: "",
        buttonName: "",
        loginLink: "",
      };
      newData.paramValue = `${newData.paramValue || "param"}_copy`;
    }

    setMessageFormData(newData);
    setIsAddMode(true);
    setIsModalOpen(true);
  };

  const handleCopyLink = () => {
    const param = rowData?.paramValue;

    if (!param) {
      toast.error("No param value found to copy");
      return;
    }

    const baseUrl = APP_URL || window.location.origin;

    const url = `${baseUrl}/onboarding?book_template=${param}`;

    navigator.clipboard
      .writeText(url)
      .then(() => toast.success("Onboarding link copied!"))
      .catch(() => toast.error("Failed to copy link"));
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="h-5 w-5 cursor-pointer fill-amber-900"
        onClick={handleEdit}
      />
      <BsTrash
        className="h-5 w-5 cursor-pointer fill-amber-900"
        onClick={() => setIsModalOpen(true)}
      />
      <BsPlusCircle
        className="h-5 w-5 cursor-pointer fill-amber-900"
        onClick={handleAdd}
      />
      <BsClipboard
        className="h-5 w-5 cursor-pointer fill-amber-900"
        onClick={handleCopyLink}
      />

      <DeleteModal
        isOpen={isModalOpen && !isAddMode}
        onRequestClose={() => setIsModalOpen(false)}
        onDelete={handleDeleteConfirm}
      />

      <CreateOrUpdateOnbaord
        isOpen={isModalOpen && isAddMode}
        onClose={() => {
          setIsModalOpen(false);
          setIsAddMode(false);
        }}
        onSubmit={() => {
          setIsModalOpen(false);
          setIsAddMode(false);
          setFetchMessage(true);
        }}
        isEditMode={false}
        isAddMode={isAddMode}
      />
    </div>
  );
};

export default EditOrDeleteOnboard;
